// src/lib/stock-signalements-api.js — client du SIGNALEMENT DE MANQUE
// (Dimitri 2026-08-21). UNE donnée, plusieurs écrans : toute écriture émet
// `fbz:stock-signalements` pour que les vues ouvertes se rafraîchissent.

import { supabase } from '../supabase'

async function appel(body, methode = 'POST') {
  const { data: { session } } = await supabase.auth.getSession()
  if (!session?.access_token) throw new Error('Session expirée — reconnectez-vous.')
  const res = await fetch('/api/beds24-mapping', {
    method: methode,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session.access_token}` },
    body: JSON.stringify(body),
  })
  const json = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(json.error || `HTTP ${res.status}`)
  return json
}

/** L'agent signale un manque — { logementId, echeance, csId?, texte? }. */
export async function signalerManque({ logementId, echeance, csId = null, texte = null }) {
  const json = await appel({ action: 'stock_signaler', logement_id: logementId, echeance,
    ...(csId ? { cs_id: csId } : {}), ...(texte ? { texte } : {}) })
  window.dispatchEvent(new Event('fbz:stock-signalements'))
  return json
}

/** Les signalements OUVERTS du périmètre (orchestrateur / admin). */
export async function fetchManques() {
  // BEST-EFFORT : toute erreur rend [] — un bloc de manques ne casse jamais
  // un écran de pilotage.
  try {
    const params = new URLSearchParams({ action: 'stock_signalements_liste' })
    const { data: { session } } = await supabase.auth.getSession()
    if (!session?.access_token) return []
    const res = await fetch(`/api/beds24-mapping?${params}`, {
      headers: { Authorization: `Bearer ${session.access_token}` },
    })
    if (!res.ok) return []
    const json = await res.json().catch(() => ({}))
    return Array.isArray(json?.signalements) ? json.signalements : []
  } catch (e) {
    console.error('[manques]', e?.message || e)
    return []
  }
}

/** Clôture à la main (orchestrateur / admin). */
export async function reglerManque(id) {
  const json = await appel({ action: 'stock_signalement_regler', id })
  window.dispatchEvent(new Event('fbz:stock-signalements'))
  return json
}

/** TOUT L'ÉCRAN STOCK en un appel (orchestrateur / admin). Best-effort null. */
export async function fetchStockVue() {
  try {
    const { data: { session } } = await supabase.auth.getSession()
    if (!session?.access_token) return null
    const res = await fetch(`/api/beds24-mapping?${new URLSearchParams({ action: 'stock_vue' })}`, {
      headers: { Authorization: `Bearer ${session.access_token}` },
    })
    if (!res.ok) return null
    return await res.json()
  } catch (e) {
    console.error('[stock_vue]', e?.message || e)
    return null
  }
}
